import useMutationApi from '../useMutationApi';

const useDeleteDivision = (divisionId: string, onSuccess?: () => void) => {
  return useMutationApi<void, void>({
    endpoint: `organization/divisions/${divisionId}`,
    method: 'DELETE',
    options: {
      onSuccess,
    },
    successMessage: 'Division deleted successfully',
    showSuccessToast: true,
  });
};

export default useDeleteDivision;
